import { render, staticRenderFns } from "./SituacaoManage.vue?vue&type=template&id=039933b4&scoped=true"
import script from "./SituacaoManage.vue?vue&type=script&lang=js"
export * from "./SituacaoManage.vue?vue&type=script&lang=js"
import style0 from "./SituacaoManage.vue?vue&type=style&index=0&id=039933b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039933b4",
  null
  
)

export default component.exports